<template>
  <div class="popup" v-show="taskSingleShow" v-cloak id="taskSingleTeamTransferPop">
    <div id="pleaseSelect" class="content">
      <div class="title">
        <span>{{$t('language.popup.cloudTransferPopup.pleaSelect')}}</span>
        <div class="icon white-close dialog-close" @click="taskSigleClose"></div>
      </div>
      <div class="task-content" v-loading="loading" ref="aimTree">
        <el-scrollbar style="height:100%;" ref="elscrollbar">

          <div>
            <div v-if="!model.length&&!loading" class='real-nodrives' @click="toAddCloudPage()">
              <div class="nondrive-realtime"></div>
              <div class="team-nondrive-realtimedes">
                {{$t('language.teamTransfer.youMust')}} <span style="color:#4755AE;font-weight:bold;">
                  {{$t('language.teamTransfer.cloudService')}}</span> {{$t('language.teamTransfer.asAdmin')}}
              </div>
            </div>
          </div>
          <div class="tree-nodes" id="treeNodes">
            <div :key="index" v-for="(item,index) in model">
              <div class="team-transfer-item" @click="checkedItem(item)">
                <div @click="checkedItem(item)" :class="[checkItem == item?'check-radio':'radio']"
                  class="icon-util  team-radio-position"></div>
                <div style="position:relative;top:3px;" :class="[item.appName?returnName(item.appName):'']"></div>
                <span @click="checkedItem(item)" style='cursor: pointer;'> {{item.name|ellipsisNavi}} </span>
              </div>

            </div>
          </div>
        </el-scrollbar>
      </div>
      <div class="task-footer">
        <button class="task-button" @click="singleSubmit()" v-loading="bloading">{{$t('language.common.ok')}}</button>
      </div>
    </div>
  </div>
</template>

<script>
  import commonUtils from "@/js/workspace/common_util.js";
  import tree from "@/components/common/trees/tree";
  import taskTransferUtils from '@/js/workspace/task_transfer_util.js';
  import commonstate from '@/js/constant.js';
  export default {
    data: function() {
      return {
        taskSingleShow: false,
        model: [],
        transferAimFlag: true,
        checkedNodes: '',
        loading: true,
        flag: true,
        scrollTopValue: 0,
        realTimeMode: true,
        pass: [],
        allModel: [], //所有的云盘长度
        checkItem: null,
        source: false, //是否是选择的源，false代表打开目标弹窗
        bloading: false, //
      };
    },
    mounted() {
      this.$store.commit('setClickItem', null);
      this.$store.commit('setArr', -1);
      let that = this;
      this.loading = false;
      this.allModel = Object.assign([], this.$store.getters.getUsersDrives);
      if (!this.allModel.length) {
        this.allModel = this.Utils.getAllCloudsList(function(res) {
          if (res.status == 200) {
            that.loading = false;
          }
        });
      } else {
        this.loading = false;
      }
      //不需要邮箱
      that.model = that.model.filter(cloud => !commonstate.emailClouds.includes(cloud.driveType));
    },
    watch: {
      allModel(newValue, oldValue) {
        if (newValue.length) {
          for (var i = 0; i < newValue.length; i++) {
            if (newValue[i].categoryInfo && newValue[i].categoryInfo.bussiness) {
              this.judgetItem(newValue[i]);
              //this.model.push(newValue[i]);
            }
          }
        }
      },
      taskSingleShow(newValue, oldValue) {
        // var _self = this;
        // var arr=[];
        // if(this.$route.name!='cloudBackup' || !newValue){
        //   return;
        // }
        // var notSupportDrive = ['oneDrive4Business','baiDu','sharedWithMe','boxBusiness','sharedDrive']
        // for (let index = 0; index < this.model.length; index++) {
        //     const element = this.model[index];
        //      if(!notSupportDrive.includes(element.appName)){//如果不在这些云盘里面则push
        //         arr.push(element);
        //    }
        // }
        // this.model = arr;
      },
    },
    methods: {
      judgetItem(item) {
        if (item.appName == "oneDrive4Business" && item.rootId == "admin") {
          this.model.push(item);
        }
        if (item.appName == "dropbox4Business" && item.rootId == "/") {
          this.model.push(item);
        }
        if (item.appName == "gSuiteSharedDrive") {
          if (item.rootId.indexOf(":") != -1) {
            var args = item.rootId.split(":");
            var userEmail = args[0];
            if ("gSuite" == userEmail) {
              this.model.push(item);
            };
          }
        }
        if (item.appName == "boxBusiness" && item.rootId == "/") {
          this.model.push(item);
        }
        if (item.appName == "gSuite" && item.rootId == "/") {
          this.model.push(item);
        }
      },
      returnName(appName) {
        let result;
        if (appName != 'ownCloud') {
          result = 'icon ' + appName + '-small';
        } else {
          result = 'icon ' + appName + '-small-box';
        }
        return result;
      },
      checkedItem(item) {
        this.checkItem = item;
      },
      taskSigleClose() {
        let that = this;
        that.taskSingleShow = false;
        this.scrollTopValue = 0;
      },
      refresh() {
        this.$forceUpdate();
      },
      toAddCloudPage() {
        let dom;
        let that = this;
        $.each(that.$parent.$parent.$children, function(i, item) {
          if (item.menuOptions) {
            dom = that.$parent.$parent.$children[i];
            dom.menuOptionSelect(10);
            return;
          }
        });
      },
      singleSubmit() {
        //  console.log(this.checkItem);
        let user = commonUtils.getUser();
        var _self = this;
        if (!_self.checkItem) { //如果没有选中任何云盘则关闭弹窗
          this.taskSingleShow = false;
          return;
        }
        //    if(!_self.source){
        //        if(_self.checkItem.appName == 'gSuiteSharedDrive'){
        //               _self.$toast({
        //               text:this.$t('language.teamTransfer.notSelected'),
        //               type: 'fail',
        //               idValue: "taskSingleTeamTransferPop"
        //              });
        //              return;
        //        }
        //    }
        if (!_self.checkItem.data) {
          this.bloading = true;
          //列出所选择云盘的menbers
          var data = {
            dd: this.checkItem.id,
            dp: this.checkItem.rootId,
            ud: user.id
          }
          if (this.checkItem.appName == 'dropbox4Business') {
            data.dp = 'Members';
          }
          this.Utils.doBusinessTransferRequest('members', data).then(data => {
            _self.checkItem.data = data;
            for (var i = 0; i < _self.checkItem.data.members.length; i++) {
              _self.checkItem.data.members[i].open = true;
              _self.checkItem.data.members[i].aimOpen = true;
            }
            if (_self.source) { //如果打开的是源云盘
              if (_self.$parent.fromDrives.length && _self.checkItem.name != _self.$parent.fromDrives[0].name) {
                _self.$parent.pair = [];
              }
              _self.$parent.fromDrives = [];
              _self.$parent.fromDrives.push(_self.checkItem);
            } else {
              if (_self.$parent.aimDrives.length && _self.checkItem.name != _self.$parent.aimDrives[0].name) {
                _self.$parent.pair = [];
              }
              _self.$parent.aimDrives = [];
              _self.$parent.aimDrives.push(_self.checkItem);
            }
            _self.taskSingleShow = false;
            _self.bloading = false;
          }).catch(err => {
            _self.bloading = false;
			if(err.reason){
			    err = _self.$t("language.exception." + err.reason)
			}
            _self.$toast({
              text: err,
              type: 'fail',
              idValue: "taskSingleTeamTransferPop"
            });
          });
        } else {
          for (var i = 0; i < _self.checkItem.data.members.length; i++) {
            _self.checkItem.data.members[i].open = true;
            _self.checkItem.data.members[i].aimOpen = true;
          }
          if (_self.source) { //如果打开的是源云盘
            if (_self.$parent.fromDrives.length && _self.checkItem.name != _self.$parent.fromDrives[0].name) {
              _self.$parent.pair = [];
            }
            _self.$parent.fromDrives = [];
            _self.$parent.fromDrives.push(_self.checkItem);

          } else {
            if (_self.$parent.aimDrives.length && _self.checkItem.name != _self.$parent.aimDrives[0].name) {
              _self.$parent.pair = [];
            }
            _self.$parent.aimDrives = [];
            _self.$parent.aimDrives.push(_self.checkItem);
          }
          _self.taskSingleShow = false;
        }
        this.scrollTopValue = this.$refs.aimTree.scrollTop;
        this.$refs.aimTree.scrollTop = 0;
      },
    },
    filters: {
      ellipsisNavi(value) {
        if (!value) return '';
        if (value.length > 39) {
          return value.slice(0, 39) + '...';
        }
        return value;
      },
    }

  };
</script>

<style>
  .el-scrollbar .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  .team-transfer-item {
    width: 100%;
    height: 40Px;
    cursor: pointer;
    line-height: 40Px;
  }

  .team-transfer-item:hover {
    width: 100%;
    height: 40Px;
    cursor: pointer;
    background: #f5f7fa;
    line-height: 40Px;
  }

  .team-radio-position {
    position: relative;
    top: 3Px;
    margin-right: 5Px;
    cursor: pointer;
    margin-left: 15Px;
  }

  #pleaseSelect .task-button .el-loading-mask {
    background-color: #5166BD;
    z-index: 0;
  }

  #pleaseSelect .task-button .el-loading-spinner .path {
    stroke: #ffffff !important;
  }

  #taskSingleTeamTransferPop {
    color: #606266;
  }
</style>



// WEBPACK FOOTER //
// src/components/popup/cloud_transfer_popups/team_transfer_source_popup.vue